import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ViewDate from "../../../../Components/Masters/ViewDate";
import { getMonthName } from "../../../../utils/getMonthName";
import { truncateNumber } from "../../../../utils/common";
import { useUser } from "../../../../context/AuthContext";
function ViewData({
  title,
  inputData,
  element,
  viewData,
  setViewData,
  handleEdit,
  setData,
}) {
  const [filteredData, setFilteredData] = useState({});
  const { user } = useUser();

  useEffect(() => {
    if (element) {
      setFilteredData(element);
    }
  }, [element]);

  const renderQuantity = (value) => (
    <div>
      {value?.vendorLegalName && <span>{value?.vendorLegalName}</span>}
      <span>{truncateNumber(value?.value) || 0} </span>
      <span>{value?.unit}</span>
    </div>
  );

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            setViewData(false);
            setData({});
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          {title}
        </Typography>

        <Grid container spacing={2}>
          <ViewDate data={element} />
          {inputData.map((input) => {
            const value = filteredData?.[input.fieldName];
            // if (value === undefined || value === null) return null;

            let displayValue;
            displayValue =
              input.fieldName === "consumptionPeriod"
                ? getMonthName(value?.month) + " " + value?.year
                : value?.unit
                ? renderQuantity(value)
                : value?.productName || value?.value || value || "-";
            // }

            return (
              <Grid item xs={12} sm={12} key={input.fieldName}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {input?.title}
                </Typography>
                <div>
                  {/* {Array.isArray(input.options)
                    ? input.options.includes(displayValue)
                      ? displayValue
                      : "-" */}
                  {displayValue}
                </div>
              </Grid>
            );
          })}
        </Grid>

       {!user?.companyAdmin && ( <Button
          variant="contained"
          sx={{
            mt: 2,
            backgroundColor: "#0a3f73",
            textTransform: "none",
            position: "fixed",
            bottom: "2rem",
          }}
          onClick={handleEdit}
        >
          Edit
        </Button>)}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => {
        setViewData(false);
        setData({});
      }}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default ViewData;
